import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Faq } from "../../Constant";
import Articals from "./Articals";
import Questions from "./Questions/indx";
import FAQFeaturesTutorial from "./FAQFeaturesTutorial";
import ArticeVideo from "./ArticeVideo";

const FaqContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Faq} parent={Faq} title={Faq} />
      <Container fluid>
        <div className="faq-wrap">
          <Row>
            <Articals />
            <Questions />
            <FAQFeaturesTutorial />
            <ArticeVideo />
          </Row>
        </div>
      </Container>
    </>
  );
};

export default FaqContainer;
